export default "__VITE_ASSET__hCoj2pHj__"